import React from "react";
import { SDLCMetadataTypeGuards, } from "@sscs/types";
import { Card, HighlightMatch, KeyValueList, Section, ValueOrPlaceholder, } from "@sscs/ui";
import { capitalizeFirstLetter, getClassName } from "@sscs/utils";
import { COMMUNITY_TYPE_TO_TEXT } from "../../../constants";
import { PolicyAudit } from "../index";
import styles from "./softwareIdentity.module.scss";
const SCENARIO_TO_TEXT = {
    develop: "Development",
    release: "Release",
};
const transformIdentityValues = ([key, value]) => {
    if (key.toLowerCase() === "purl") {
        return [key.toUpperCase(), value];
    }
    else if (key.toLowerCase() === "community") {
        return [
            capitalizeFirstLetter(key),
            SDLCMetadataTypeGuards.stringIsCommunityType(value)
                ? COMMUNITY_TYPE_TO_TEXT[value]
                : value,
        ];
    }
    else {
        return [capitalizeFirstLetter(key), value];
    }
};
const SoftwareIdentity = ({ identity, verifiedMatchesFilter = [], highlightScenario = false, className, link, }) => {
    return (React.createElement("div", { className: getClassName(styles.identity, className) },
        React.createElement(Card.Card, null,
            React.createElement(Card.Title, { actions: link }, "Software identity"),
            React.createElement(Card.Content, null,
                React.createElement(KeyValueList, { list: {
                        Product: React.createElement(ValueOrPlaceholder, { value: identity.product }),
                        Version: React.createElement(ValueOrPlaceholder, { value: identity.version }),
                        Publisher: React.createElement(ValueOrPlaceholder, { value: identity.publisher }),
                        PURL: (React.createElement("code", null,
                            React.createElement(ValueOrPlaceholder, { value: identity.purl }))),
                        "Verified by": identity.verified,
                        "Verified matches": identity.matches.length > 0 ? (React.createElement(React.Fragment, null, identity.matches.map((match, index) => (React.createElement(React.Fragment, { key: match },
                            React.createElement(HighlightMatch, { value: match, regex: verifiedMatchesFilter.join("|") }),
                            index < identity.matches.length - 1 ? ", " : null))))) : (React.createElement(HighlightMatch, { value: "--", regex: identity.verified === "Not verified" &&
                                (verifiedMatchesFilter === null || verifiedMatchesFilter === void 0 ? void 0 : verifiedMatchesFilter.includes("Not verified"))
                                ? "--"
                                : "" })),
                        "Software type": (React.createElement(ValueOrPlaceholder, { value: capitalizeFirstLetter(identity.type) })),
                        "Use scenario": (React.createElement("div", { className: highlightScenario ? styles.highlight : undefined },
                            "During ",
                            SCENARIO_TO_TEXT[identity.scenario],
                            identity.install === "optional" &&
                                ` (${capitalizeFirstLetter(identity.install)})`)),
                        Category: (React.createElement(ValueOrPlaceholder, { value: capitalizeFirstLetter(identity.category) })),
                        Community: COMMUNITY_TYPE_TO_TEXT[identity.community],
                        License: React.createElement(ValueOrPlaceholder, { value: identity.license }),
                        Description: React.createElement(ValueOrPlaceholder, { value: identity.description }),
                        CPE: (React.createElement("code", null,
                            React.createElement(ValueOrPlaceholder, { value: identity.cpe }))),
                    } }))),
        identity.edit.present ? (React.createElement(Card.Card, null,
            React.createElement(Card.Title, null, "Software identity edit record"),
            React.createElement(Card.Content, { className: styles["edit-record"] },
                React.createElement(PolicyAudit, { audit: identity.edit, title: "Audit", nested: true }),
                React.createElement(Section, null,
                    React.createElement(Section.Title, null, "Original identity"),
                    React.createElement(Section.Content, null, identity.original.length > 0 ? (React.createElement(KeyValueList, { list: Object.fromEntries(identity.original
                            .map(transformIdentityValues)
                            .map(([key, value]) => [
                            key,
                            key === "PURL" ? (React.createElement("code", { key: key },
                                React.createElement(ValueOrPlaceholder, { value: value }))) : (React.createElement(ValueOrPlaceholder, { key: key, value: value })),
                        ])) })) : ("The component did not have identity information before the edit")))))) : null));
};
export default SoftwareIdentity;
//# sourceMappingURL=SoftwareIdentity.js.map